import React from 'react';
import TextArea from '../../atoms/TextArea';
import EnterButton from '../../atoms/Button/EnterButton';

const InputBox = ({ onChange, onKeyDown, value, onSend, progress }) => {
  return (
    <div className="fixed bottom-0 z-[999] flex min-h-[120px] w-full flex-col items-center border border-b-0 border-l-0 border-r-0 bg-white pt-2">
      <div className="flex w-3/4 rounded-2xl border border-gray-300 px-4 py-2 lg:w-1/2">
        <TextArea
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={progress ? 'Enter prompt...' : 'Generating...'}
          value={value}
        />
        <EnterButton onClick={onSend} />
      </div>
      <div className="my-auto text-xs text-gray-800">
        Please verify information independently as LLM responses may not be 100%
        accurate
      </div>
    </div>
  );
};

export default InputBox;
